import { Collapse } from 'antd';
import BackgroundImageUploader from '../imageUploader/backgroundImageUploader'

const { Panel } = Collapse;

const BackgroundImage = () => {
  
  
  return (
    <Collapse  defaultActiveKey={['0']} >

      <Panel header="Loder Image"  key="1"  >
       
      <BackgroundImageUploader/>
      </Panel>

    </Collapse>
  );
};
export default BackgroundImage